import React, { FC } from 'react'
import styled from 'styled-components'

export type Props = {
  activeSlide: number
}

export const SliderContent: FC<Props> = ({ children, activeSlide, ...restProps }) => {
  return (
    <StyledSliderContent {...restProps} activeSlide={activeSlide}>
      {children}
    </StyledSliderContent>
  )
}

const StyledSliderContent = styled.div<Props>`
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  transform: translateX(-${({ activeSlide }) => activeSlide * 100}%);
`
